package com.vamvisions.main.portfolio.presentation.common

import com.vamvisions.main.core.presentation.navigation.Route
import com.vamvisions.main.core.presentation.navigation.RouteParser

/** Where a link goes: a page of this website, or another site. */
sealed interface LinkTarget {
    data class Internal(val route: Route) : LinkTarget
    data class External(val url: String) : LinkTarget
}

/** A site-relative [url] (starting with `/`) is a page of this website; anything else is external. */
fun linkTargetOf(url: String): LinkTarget =
    if (url.startsWith("/") && !url.startsWith("//")) LinkTarget.Internal(RouteParser.parse(url)) else LinkTarget.External(url)
